import React from 'react';
const LoadingContext = React.createContext(false);
export default LoadingContext;
